import { FormFieldSelect } from "../../../BuildingBlocks/Forms/MantineFormFields/fields/FormFieldSelect";
import { UNKNOWN_USER } from "../../Todos.constants";
import type { TodoUser } from "../../Todos.types";

interface TodoResponsibleCellProps {
  responsibleId: number | null;
  users: Array<TodoUser>;
  todoId: number;
  universal: boolean;
  onChangeResponsible: (responsibleId: number | null, todoId: number) => void;
}

function TodoResponsibleCell({
  responsibleId,
  users,
  todoId,
  universal,
  onChangeResponsible
}: TodoResponsibleCellProps) {
  if (universal) {
    return (
      <UniversalResponsibleCell responsibleId={responsibleId} users={users} />
    );
  }

  const selectableUsers = users.filter(
    (user) => !user.isSystemUser || responsibleId === user.id
  );
  const responsibleUserIsUnknown = !selectableUsers.find(
    (user) => user.id === responsibleId
  );

  return (
    <FormFieldSelect
      clearable
      data={[
        ...selectableUsers.map((user) => ({
          value: String(user.id),
          label: user.name
        })),
        ...(responsibleUserIsUnknown && responsibleId !== null
          ? [{ value: String(responsibleId), label: UNKNOWN_USER }]
          : [])
      ]}
      type="select"
      value={responsibleId ? String(responsibleId) : ""}
      onChange={(value) =>
        onChangeResponsible(value !== null ? Number(value) : null, todoId)
      }
    />
  );
}

function UniversalResponsibleCell({
  responsibleId,
  users
}: Pick<TodoResponsibleCellProps, "responsibleId" | "users">) {
  const responsibleUser = responsibleId
    ? users.find((user) => user.id === responsibleId)
    : null;
  const responsibleName = responsibleUser ? responsibleUser.name : UNKNOWN_USER;

  return (
    <span className="label-cell-text">
      {responsibleId ? responsibleName : ""}
    </span>
  );
}

export { TodoResponsibleCell };
